export default __webpack_public_path__ + "static/media/reanudar_cursado.44fcd9ac.svg";